module.exports = "/assets/home-page/media/forbes.png?+vO15zw";